import CategoryView from "@/pages/category/components/CategoryView";
import { tvList } from "@/utils/mediaData";

export default function TvCategoryPage() {
  return (
    <CategoryView
      type="tv"
      items={tvList}
      title="电视剧频道"
      description="精选热播及经典电视剧资源，方便观看与查找"
      breadcrumb="电视剧"
      bannerImage="https://readdy.ai/api/search-image?query=A%20cozy%20modern%20living%20room%20with%20a%20large%20television%20glowing%20at%20night%2C%20cinematic%20editorial%20photography%2C%20warm%20amber%20lighting%20with%20deep%20blue%20shadows%2C%20high%20detail%2C%20wide%20composition&width=1600&height=500&seq=category-banner-tv&orientation=landscape"
    />
  );
}